
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2055_6120)","stroke":"#709C75"}},[_c('path',{attrs:{"d":"M11.334 5.492L6.75 10.167 4.667 8.042","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14.834 8.164c0 3.782-3.06 6.847-6.834 6.847-3.773 0-6.833-3.065-6.833-6.847 0-3.782 3.06-6.847 6.833-6.847s6.834 3.065 6.834 6.847z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2055_6120"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .15)","d":"M0 0h16v16.029H0z"}})])])])
          )
        }
      }
    